import { SectionModel } from '@/types/sections.model';

export interface AppDataModel {
  name: string;
  description: string;
  logo: string;
  language: string;
  sections: SectionModel[];
  socials: {
    icon: string;
    link: string;
  }[];
  footer: {
    copyright: string;
    links: Array<{
      label: string;
      link: string;
    }>;
  };
}

export const sections: SectionModel[] = [
  {
    type: 'hero',
    id: 'hero-section',
    content: {
      title: 'UNLOCK YOUR POSSIBILITIES',
      subtitle: 'Svela tutte le possibilità.',
      image: '/assets/image/hero.jpg',
      imageMobile: '/assets/image/hero_mobile.jpg',
    }
  },
  {
    type: 'anchor',
    id: 'main-content',
    items: [
      { label: 'UNLOCK YOUR POSSIBILITIES', link: '#unlock-your-possibilities' },
      { label: 'COLORE', link: '#colore' },
      { label: 'FORMA', link: '#forma' },
      { label: 'TRATTAMENTO', link: '#trattamento' },
      { label: 'RASSEGNA STAMPA', link: '#rassegna-stampa' },
    ]
  },
  {
    type: 'video',
    id: 'unlock-your-possibilities',
    media: {
      type: 'video',
      source: '/assets/video/video_1.mov',
      poster: '/assets/video/frame_1.jpg',
      title: 'Video Title',
      autoplay: false,
      loop: false,
      muted: true,
      controls: true,
      aspectRatio: '16/9',
    }
  },
  {
    type: 'testimonial',
    id: 'unlock-your-possibilities-2',
    style: {
      alignment: 'flex-start'
    },
    content: {
      title: 'Possibilità di svelare ogni sfumatura di bellezza',
      subtitle: 'Alter Ego Italy, dal 1988, unisce gusto italiano, rigore scientifico e cura artigianale per offrire agli hairstylist nuove visioni di bellezza.',
    },
    items: [
      {
        type: 'video',
        source: '/assets/video/video_2.mp4',
        poster: '/assets/video/frame_2.jpg',
        title: 'Video Title',
        autoplay: false,
        loop: false,
        muted: true,
        controls: true,
        aspectRatio: '16/9',
      },
      {
        type: 'image',
        source: '/assets/image/DS_Media_Overlay.png',
        title: 'Immagine 2'
      },
    ]
  },
  {
    type: 'testimonial',
    id: 'unlock-your-possibilities-3',
    style: {
      alignment: 'flex-end'
    },
    reverse: true,
    content: {
      title: 'Possibilità di soddisfare esigenze davvero uniche',
      subtitle: 'Trasformare il salone in un luogo in cui tutto diventa possibile.',
    },
    items: [
      {
        type: 'video',
        source: '/assets/video/video_3_full.mp4',
        poster: '/assets/video/frame_3_full.jpg',
        title: 'Video Title',
        autoplay: false,
        loop: false,
        muted: true,
        controls: true,
        aspectRatio: '16/9',
      },
      {
        type: 'video',
        source: '/assets/video/video_3_vertical.mp4',
        poster: '/assets/video/frame_3_vertical.jpg',
        title: 'Video Title',
        autoplay: false,
        loop: false,
        muted: true,
        controls: true,
        aspectRatio: '9/16',
      },
    ]
  },
  {
    type: 'testimonial',
    id: 'testimonial-section-3',
    content: {
      title: 'Possibilità di essere il mago che svela ogni bellezza',
      subtitle: 'Al fianco degli Hairstylist contemporanei, che, proprio come un mago, sanno trasformare e rivelare la bellezza in ogni possibile sfumatura.',
    },
    items: [
      {
        type: 'image',
        source: '/assets/image/testimonial3.jpg',
        title: 'Immagine 1'
      },
      {
        type: 'video',
        source: '/assets/video/video_4_vertical.mp4',
        poster: '/assets/video/frame_4_vertical.jpg',
        title: 'Video Title',
        autoplay: false,
        loop: false,
        muted: true,
        controls: true,
        aspectRatio: '9/16',
      },
    ]
  },
  {
    type: 'media-grid',
    id: 'colore',
    content: {
      title: 'Libera i colori',
      subtitle: 'Rivelare le sfumature, riflettere la luce, scatenare le cromie.',
      caption: 'Con Alter Ego Italy il colore diventa pura ispirazione: luce, emozione e identità si intrecciano in formule d\'eccellenza che svelano le infinite sfumature di bellezza di ogni donna.'
    },
    items: [
      {
        type: 'image',
        source: '/assets/image/Frame 816.png',
        title: 'Immagine 1'
      },
      {
        type: 'image',
        source: '/assets/image/Frame 817.png',
        title: 'Immagine 2'
      },
    ]
  },
  {
    type: 'media-grid',
    id: 'forma',
    content: {
      title: 'Crea le forme',
      subtitle: 'Dare volume, creare texture, disegnare contorni, scolpire icone.',
      caption: 'Il gesto tecnico diventa espressione: formule innovative e protettive svelano la bellezza autentica, tra texture sensoriali e fragranze che ispirano creatività.'
    },
    items: [
      {
        type: 'image',
        source: '/assets/image/Frame 816_2.png',
        title: 'Immagine 1'
      },
      {
        type: 'image',
        source: '/assets/image/Frame 817_2.png',
        title: 'Immagine 2'
      },
    ]
  },
  {
    type: 'media-grid',
    id: 'trattamento',
    content: {
      title: 'Esalta il trattamento',
      subtitle: 'Prendersi cura di cute, valorizzare le lunghezze, esaltare il colore.',
      caption: 'Ogni trasformazione nasce dalla cura: con tecnologie avanzate e attivi performanti, per offrire trattamenti su misura che donano benessere e bellezza. '
    },
    items: [
      {
        type: 'image',
        source: '/assets/image/Frame 816_3.png',
        title: 'Immagine 1'
      },
      {
        type: 'image',
        source: '/assets/image/Frame 817_3.png',
        title: 'Immagine 2'
      },
    ]
  },
  {
    type: 'quote',
    id: 'rassegna-stampa',
    items: [
      {
        text: "La bellezza è consapevolezza quando portiamo dentro di noi un significato",
        author: {
          name: "Vogue",
          image: "/assets/image/vogue.png"
        }
      },
      {
        text: "L’hair-stylist diventa guida e complice di un percorso di trasformazione, elegante e silenzioso, capace di restituire fiducia e valorizzare l’unicità di ciascuno",
        author: {
          name: "ESTETICA",
          image: "/assets/image/Estetica.png"
        }
      },
      {
        text: "L’hairstylist: una figura elegante e silenziosa che, con prodotti di qualità e mani esperte, come fosse un mago, offre nuove possibilità di espressione a ciascuno di noi",
        author: {
          name: "COLORAMI",
          image: "/assets/image/Colorami.png"
        }
      },
      {
        text: "Un messaggio universale, una promessa di empowerment, libertà e scoperta che parla contemporaneamente all’hair-stylist, dal ruolo creativo e trasformativo, e al consumatore finale",
        author: {
          name: "MEDIA KEY",
          image: "/assets/image/Media Key.png"
        }
      },
      {
        text: "Un racconto visivo emozionante, dal tono di voce ispirazionale, autorevole e raffinato, in cui il salone diventa palcoscenico di rinascita",
        author: {
          name: "TOUCH POINT",
          image: "/assets/image/touchpoint-logo-black.svg"
        }
      },
      {
        text: "Un invito a vivere la bellezza come atto di trasformazione, libertà ed espressione personale",
        author: {
          name: "BEAUTY2BUSINESS",
          image: "/assets/image/b2B2-2.png"
        }
      },
    ]
  }
];

export const appData: AppDataModel = {
  name: "Alterego IT",
  description: "Svela tutte le possibilità.",
  logo: "/logo-alterego-it.svg",
  language: "it",
  sections,
  socials: [
    { icon: 'facebook', link: 'https://www.facebook.com/alteregoitalyhq' },
    { icon: 'instagram', link: 'https://www.instagram.com/alteregoitalyhq/?hl=it' },
    { icon: 'tiktok', link: 'https://www.tiktok.com/@alteregoitaly' },
    { icon: 'youtube', link: 'https://www.youtube.com/user/alteregoitaly' }
  ],
  footer: {
    copyright: "© 2025 Alter Ego Italy — All Rights Reserved",
    links: [
      { label: 'Privacy Policy', link: 'https://www.alteregoitaly.com/ae_it/privacy-policy' },
      // { label: 'Terms of Service', link: '/terms' },
      { label: 'Cookies Settings', link: 'https://www.alteregoitaly.com/ae_it/cookie-policy' }
    ]
  }
};



export default appData;